<template><div><h1 id="sind-filter-filterpositionen-filtergrenzen-immer-inklusive" tabindex="-1"><a class="header-anchor" href="#sind-filter-filterpositionen-filtergrenzen-immer-inklusive"><span>Sind Filter / Filterpositionen / Filtergrenzen immer inklusive?</span></a></h1>
<h2 id="frage" tabindex="-1"><a class="header-anchor" href="#frage"><span>Frage:</span></a></h2>
<p>Wenn ich einen Filter definiere, dessen Filterposition einen Wertebereich festlegt, sind die Bereichsgrenzen immer in der Menge enthalten?</p>
<h2 id="antwort" tabindex="-1"><a class="header-anchor" href="#antwort"><span>Antwort:</span></a></h2>
<p>Ja, Bereichsgrenzen von Wertebereichen sind immer inklusive und müssen manuell exkludiert werden.</p>
<h2 id="hintergrund" tabindex="-1"><a class="header-anchor" href="#hintergrund"><span>Hintergrund</span></a></h2>
<p>funtrade bietet in den Filtern mit den vorgefertigten Filterpositionen ein mächtiges Werkzeug, komplizierte Abfragen in einer einfachen Art und Weise zu definieren.</p>
<p>Dabei verfolgen alle Filterpositionen den Grundsatz, dass, falls ein Wertebereich angegeben werden kann, dieser immer die Bereichsgrenzen miteinbezieht, sprich <strong>inklusive</strong> ist.</p>
<p>Die häufigsten Wertebereiche sind:</p>
<ul>
<li>Wert von – bis</li>
<li>Datum von – bis</li>
<li>Anzahl von – bis</li>
</ul>
<p>Um besser zu verstehen, was das Resultat ist, wenn diese Filterpositionen auf einen Datensatz angewendet werden, schauen wir uns ein paar Beispiele an:</p>
<ol>
<li>Filter mit einer Position <code v-pre>Personen-ID: 10'000 - 11'000</code></li>
</ol>
<ul>
<li>Es werden alle Personen, inklusive der Person mit ID 10'000 sowie auch der Person mit ID 11'000 selektiert</li>
</ul>
<ol start="2">
<li>Filter mit einer Position <code v-pre>Eintritt Zusage: {1} Datum: 1.1.2022 – 1.1.2023</code></li>
</ol>
<ul>
<li>Es werden alle Personen mit Zusagen selektiert, deren Zusage am 1.1.2022 bis und mit 1.1.2023 registriert wurden</li>
<li>Achtung: sollen alle Personen mit Zusagen aus dem Jahr 2022 selektiert werden, müssen folgende Daten angegeben werden: 1.1.2022 – 31.12.2022</li>
</ul>
<ol start="3">
<li>Filter mit mehreren Filterpositionen, um «Neuspender» zu finden:</li>
</ol>
<ul>
<li>Kriterien: Hat in den letzten 3 Monaten 1 Mal gespendet, aber früher noch nicht</li>
<li>Referenzwert «Tagesdatum»</li>
<li>Filterpositionen:<div class="language-text line-numbers-mode" data-highlighter="prismjs" data-ext="text"><pre v-pre><code><span class="line">Anzahl Response-Ereignis: 1 - 1 Umsatztyp: SPE Datum: &lt;Tagesdatum (-92D)> - &lt;Tagesdatum></span>
<span class="line">und nicht</span>
<span class="line">Anzahl Response-Ereignis: 1 - 1 Umsatztyp: SPE Datum: {} - &lt;Tagesdatum (-93D)></span>
<span class="line"></span></code></pre>
<div class="line-numbers" aria-hidden="true" style="counter-reset:line-number 0"><div class="line-number"></div><div class="line-number"></div><div class="line-number"></div></div></div></li>
<li>Achtung: Um eine Doppelzählung am Tag <code v-pre>&lt;Tagesdatum (-92D)</code> zu vermeiden, ist in der zweiten Filterposition <code v-pre>&lt;Tagesdatum (-93D)&gt;</code> anzugeben.</li>
</ul>
<div class="hint-container tip">
<p class="hint-container-title">Tipp</p>
<p>Weitere Hinweise zum Erstellen von Filtern mit mehreren Filterpositionen sind im FAQ <RouteLink to="/faq/07-mehrere-filterpositionen-erfassen.html">«Auf was muss ich achten, wenn ich Filter mit mehreren Filterpositionen erstelle?»</RouteLink>.</p>
</div>
</div></template>


